package org.multiplatform.kotfolio.pages.compose.side_effect

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul

@Page("/compose/side_effect/remember_serializable")
@Composable
fun RememberSerializablePage() {
    BlogLayout(
        PageProperties(
            "rememberSerializable",
            "kotlinx.serialization to serialize your state class to JSON, stores it in the Bundle via SavedStateHandle - no Parcelable boilerplate needed. Just annotate with @Serializableand you're done.",
        ),
        BlogProperties("Jetpack Compose", "rememberSerializable")
    )
    {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This ensures your object is actually serializable. Useful when using KotlinX serialization.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "How it works",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Uses kotlinx.serialization to serialize your state class to JSON, stores it in the Bundle via SavedStateHandle - no Parcelable boilerplate needed. Just annotate with @Serializableand you're done.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Process Death vs. Configuration Changes",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Process death → rememberSerializable() handles this. Your state is persisted to the Bundle and restored when the system recreates the process.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Configuration changes → The Compose team still recommends leaning on a ViewModel for this case.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }


            KotlinCode(
                code = $$"""
                    @Serializable
                    data class UserPreferences(val theme: String)

                    @Composable
                    fun PreferenceScreen() {
                        val prefs = rememberSerializable {
                            UserPreferences(theme = "light")
                        }

                        Text("Theme: ${prefs.theme}")
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Serializable
                    data class FilterState(
                        val query: String = "",
                        val sortBy: SortOrder = SortOrder.NAME
                    )
                    
                    var filter by rememberSerializable { mutableStateOf(FilterState()) }
                    """.trimIndent()
            )
        }
    }
}